<script lang='ts'>
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { loginUser, user } from '../store';
import { HttpError, login } from '../services';
import * as config from '../config.json';

export let title;
export let subtitle;

interface LoginResponse {
  id: string;
  token: string;
  first: string;
  last: string;
}

const navigate = useNavigate();
const location = useLocation();

let email = '';
let password = '';
let showJustChangedPassword;

$: {
  const params = new URLSearchParams($location.search);
  showJustChangedPassword = params.get('changed') === '1';
}

let error;
let loading = false;

async function handleSubmit() {
  showJustChangedPassword = false;
  error = undefined;

  if (email.length === 0 || password.length === 0) {
    error = 'Please enter your email and password';
    return;
  }

  loading = true;

  try {
    const {id, first, last, token} = await login<LoginResponse>({email, password, eventId: config.eventId, companyId: config.companyId});
    loginUser(id, token, email, first, last)
    navigate('/', { replace: true });
  } catch (e) {
    if (e instanceof HttpError && e.status === 401) {
      error = "Incorrect email or password";
    } else {
      console.error(e);
      error = e.message;
    }
  } finally {
    loading = false;
  }
}
</script>

<div class="login-title">
  {@html title}
</div>

<div class="login-subtitle">
  {@html subtitle}
</div>

{#if showJustChangedPassword}
  <div class="success-box mb-4">Your password has been changed. Please login.</div>
{/if}

<form on:submit|preventDefault={handleSubmit}>
  {#if error}
    <div class="error-box mb-4">{error}</div>
  {/if}

  <div class="col mb-4">
    <div class="form-label">Email</div>
    <input bind:value={email} type="email" name="email" placeholder="Email" />
  </div>
  
  <div class="col mb-4">
    <div class="form-label">Password</div>
    <input bind:value={password} type="password" name="password" placeholder="Password" />
  </div>

  <div class="row vcenter between" style="margin-top: 48px">
    <Link to="/forgot" class="login-help-link">Forgot your password?</Link>
    <button type="submit" class="btn secondary" disabled={loading}>
      {#if loading}
        <div class='spinner' />
      {:else}
        Login
      {/if}
    </button>
  </div>
</form>